(function () {
  var config = {
    products: {
      ys16: {
        handle: "150kg-capacity-electric-wheelchair",
        name: "YS16-1 PLUS",
        sku: "YS16-1 PLUS",
        category: "power_wheelchair",
        url: "/products/150kg-capacity-electric-wheelchair",
        summary: "Best starting point for a wide-seat, heavy-duty power wheelchair for home, yard, driveway, and neighborhood use."
      },
      x024: {
        handle: "x-024-electric-mobility-scooter-with-wide-seat-for-comfortable-ride",
        name: "X-024",
        sku: "X-024",
        category: "mobility_scooter",
        url: "/products/x-024-electric-mobility-scooter-with-wide-seat-for-comfortable-ride",
        summary: "Best starting point for scooter-style seating, outdoor errands, shopping, and community trips."
      }
    },
    leadScores: {
      quiz_completed: 20,
      add_to_cart: 30,
      begin_checkout: 40,
      service_or_warranty_view: 15,
      callback_request: 40
    },
    events: [
      "view_product",
      "add_to_cart",
      "begin_checkout",
      "purchase",
      "fit_check_started",
      "fit_check_completed",
      "lead_submitted",
      "service_page_viewed"
    ]
  };

  window.AnywellMvpConfig = config;

  function track(name, params) {
    params = params || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params));
    if (typeof window.gtag === "function") window.gtag("event", name, params);
    document.dispatchEvent(new CustomEvent("anywell:event", { detail: { name: name, params: params } }));
  }

  function addLeadScore(points) {
    try {
      var current = Number(sessionStorage.getItem("anywell_lead_score") || "0");
      sessionStorage.setItem("anywell_lead_score", String(current + points));
    } catch (e) {}
  }

  function productFromPath() {
    var path = location.pathname;
    return Object.keys(config.products)
      .map(function (key) { return config.products[key]; })
      .find(function (product) { return path.indexOf("/products/" + product.handle) === 0; });
  }

  function initFunnelTracking() {
    var currentProduct = productFromPath();
    if (currentProduct) {
      track("view_product", {
        product_handle: currentProduct.handle,
        product_name: currentProduct.name,
        sku: currentProduct.sku,
        category: currentProduct.category
      });
    }

    if (/^\/pages\/(warranty|service-and-parts|repair-request|repair-request-form)/.test(location.pathname)) {
      track("service_page_viewed", { page_path: location.pathname });
      addLeadScore(config.leadScores.service_or_warranty_view);
    }

    document.addEventListener("submit", function (event) {
      var form = event.target;
      var action = (form.getAttribute("action") || "").toLowerCase();
      if (action.indexOf("/cart/add") !== -1) {
        track("add_to_cart", currentProduct ? {
          product_handle: currentProduct.handle,
          product_name: currentProduct.name,
          sku: currentProduct.sku
        } : {});
        addLeadScore(config.leadScores.add_to_cart);
      }
    }, true);

    document.addEventListener("click", function (event) {
      var el = event.target.closest ? event.target.closest("a,button,input[type='submit']") : null;
      if (!el) return;
      var href = (el.getAttribute("href") || "").toLowerCase();
      var text = (el.innerText || el.value || "").toLowerCase();
      if (href.indexOf("/checkout") !== -1 || text.indexOf("checkout") !== -1 || text.indexOf("buy it now") !== -1) {
        track("begin_checkout", currentProduct ? {
          product_handle: currentProduct.handle,
          product_name: currentProduct.name,
          sku: currentProduct.sku
        } : {});
        addLeadScore(config.leadScores.begin_checkout);
      }
    }, true);
  }

  function initFitCheck() {
    var form = document.getElementById("aw-fit-form");
    if (!form) return;

    var result = document.getElementById("aw-fit-result");
    var body = document.getElementById("aw-fit-body");
    var started = false;
    var completed = false;

    function value(name) {
      var selected = form.querySelector("[name='" + name + "']:checked");
      if (selected) return selected.value;
      var field = form.querySelector("[name='" + name + "']");
      return field ? field.value : "";
    }

    function quizComplete() {
      return value("scene") && value("door_width") && value("storage") && value("preference") && value("timeline");
    }

    function recommend() {
      var scoreYs = 0;
      var scoreX = 0;
      var scene = value("scene");
      var storage = value("storage");
      var preference = value("preference");
      var doorWidth = Number(value("door_width"));

      if (scene === "home_yard") scoreYs += 3;
      if (scene === "shopping_community") scoreX += 3;
      if (scene === "mixed") { scoreYs += 1; scoreX += 1; }
      if (preference === "wheelchair") scoreYs += 3;
      if (preference === "scooter") scoreX += 3;
      if (storage === "garage") scoreX += 1;
      if (storage === "assisted_lift") scoreYs += 1;
      if (storage === "tight_vehicle") scoreYs += 1;
      if (doorWidth && doorWidth < 32) scoreYs += 1;

      return scoreX > scoreYs ? config.products.x024 : config.products.ys16;
    }

    function renderResult() {
      var rec = recommend();
      var callbackRequested = Boolean(form.querySelector("[name='callback']:checked"));
      var leadScore = config.leadScores.quiz_completed + (callbackRequested ? config.leadScores.callback_request : 0);
      var lines = [
        "Recommendation: " + rec.name,
        rec.summary,
        "Main use: " + value("scene"),
        "Door width: " + value("door_width") + " in",
        "Storage/loading: " + value("storage"),
        "Preference: " + value("preference"),
        "Timeline: " + value("timeline"),
        "Callback requested: " + (callbackRequested ? "yes" : "no"),
        "Lead score: " + leadScore
      ];

      if (body) body.value = lines.join("\n");
      if (result) {
        result.style.display = "block";
        result.innerHTML = "<strong>Recommended starting point: " + rec.name + "</strong><br>" + rec.summary + '<br><a href="' + rec.url + '">View product</a>';
      }
      return { product: rec.name, leadScore: leadScore };
    }

    function onChange() {
      if (!started) {
        started = true;
        track("fit_check_started");
      }
      if (quizComplete()) {
        var rec = renderResult();
        if (!completed) {
          completed = true;
          track("fit_check_completed", { recommended_product: rec.product, lead_score: rec.leadScore });
          addLeadScore(config.leadScores.quiz_completed);
        }
      }
    }

    form.addEventListener("change", onChange);
    form.addEventListener("input", onChange);
    form.addEventListener("submit", function () {
      var rec = renderResult();
      track("lead_submitted", { source: "fit_check", recommended_product: rec.product, lead_score: rec.leadScore });
    });
  }

  initFunnelTracking();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFitCheck);
  } else {
    initFitCheck();
  }
})();

/* codex-cache-test-178014 */


;/* AW remove stale floating support widget 2026-05-31 */
(function(){
  function removeAwHelpWidget(){
    try{
      document.querySelectorAll('.aw-help-widget,[data-aw-help-widget],#aw-help-panel,.aw-help-panel,.aw-help-toggle').forEach(function(el){el.remove();});
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', removeAwHelpWidget); else removeAwHelpWidget();
  window.setTimeout(removeAwHelpWidget, 200);
  window.setTimeout(removeAwHelpWidget, 1000);
  window.setTimeout(removeAwHelpWidget, 3000);
})();
